import styled from 'styled-components';

export const Divider = styled.hr<{ margin?: string; padding?: string }>`
    width: 100%;
    box-sizing: border-box;
    height: 0.1rem;
    background-color: ${({ theme }) => theme.colors.grey[200]};
    border: none;
    padding: ${({ padding }) => padding};
    margin: ${({ margin }) => margin ?? '2.4rem 0'};
`;
